<template>
  <span>
    <svg slot="svg" width="18px" height="15px" viewBox="0 0 18 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M12,8.25 C14.07,8.25 15.75,9.93 15.75,12 C15.75,12.4875 15.6525,12.945 15.48,13.3725 L17.67,15.5625 C18.8025,14.6175 19.695,13.395 20.2425,12 C18.945,8.7075 15.7425,6.375 11.9925,6.375 C10.9425,6.375 9.9375,6.5625 9.0075,6.9 L10.6275,8.52 C11.055,8.3475 11.5125,8.25 12,8.25 Z M4.5,6.2025 L6.21,7.9125 L6.555,8.2575 C5.31,9.225 4.335,10.515 3.75,12 C5.0475,15.2925 8.25,17.625 12,17.625 C13.1625,17.625 14.2725,17.4 15.285,16.995 L15.6,17.31 L17.7975,19.5 L18.75,18.5475 L5.4525,5.25 L4.5,6.2025 Z M8.6475,10.35 L9.81,11.5125 C9.7725,11.67 9.75,11.835 9.75,12 C9.75,13.245 10.755,14.25 12,14.25 C12.165,14.25 12.33,14.2275 12.4875,14.19 L13.65,15.3525 C13.1475,15.6 12.5925,15.75 12,15.75 C9.93,15.75 8.25,14.07 8.25,12 C8.25,11.4075 8.4,10.8525 8.6475,10.35 Z M11.88,9.765 L14.2425,12.1275 L14.2575,12.0075 C14.2575,10.7625 13.2525,9.7575 12.0075,9.7575 L11.88,9.765 Z" id="path-1-eye-not"></path>
      </defs>
      <g id="Password-generator" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Password-generator-result" transform="translate(-814.000000, -668.000000)">
          <g id="Zarządzanie-Copy" transform="translate(292.000000, 571.000000)">
            <g id="Zasilanie" transform="translate(17.000000, 71.000000)">
              <g id="icons/Non-visible" transform="translate(502.000000, 21.000000)">
                <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
                <mask id="mask-2-eye-not" fill="white">
                  <use xlink:href="#path-1-eye-not"></use>
                </mask>
                <use id="Shape" fill-opacity="0" fill="#000000" fill-rule="nonzero" xlink:href="#path-1-eye-not"></use>
                <g id="Mixin/Fill/Active" mask="url(#mask-2-eye-not)" fill="#8D99AE" fill-rule="evenodd">
                  <rect id="Box" x="0" y="0" width="24" height="24"></rect>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </span>
</template>

<script>
export default {
  name: "DsEyeNotVisibleIcon"
};
</script>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-eye-not-visible-icon.vue